import graphql__a9de7f3e4e3844c9b1e1 from "./__generated__/LibraryFile_file.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import { Desktop } from "../Utils/ResponsiveQueries";
import Icon from "../Utils/Icon";
import ButtonLink from "../Buttons/ButtonLink";
import { useFormatMessage } from "../Intl/Context";

const LibraryFile = props => {
  const file = useFragment(LibraryFile_file, props.file);
  const { fileExtension, size, name } = file;
  const { xPadding = true } = props;

  const t = useFormatMessage();
  const downloadLabel = t(intlMessages.download);
  const fileMissingDetailsSizeLabel = t(intlMessages.fileMissingDetailsSizeLabel);
  const fileMissingDetailsExtensionLabel = t(
    intlMessages.fileMissingDetailsExtensionLabel
  );

  const className = classNames([
    "file-row",
    "d-flex",
    "flex-row",
    {
      "padding-y-sm": true,
      "padding-x-sm": xPadding
    }
  ]);

  const fileHasMissingDetailsSize = !size && size !== 0;
  const fileHasMissingDetailsExtension = !fileExtension;

  return (
    <div className={className}>
      <div className="file-title d-flex flex-row with-icon text-default align-items-center">
        <Desktop>
          <Icon className="icon-document-txt text-primary text-sign-sm margin-right-xs" />
        </Desktop>

        <div className="flex-1 flex with-icon-text font-weight-bold">
          {name}

          {!fileHasMissingDetailsExtension ? (
            <span className="margin-left-xs font-weight-normal">
              {"(" + fileExtension + ")"}
            </span>
          ) : (
            <span className="margin-left-xs font-weight-normal">
              {"(" + fileMissingDetailsExtensionLabel + ")"}
            </span>
          )}
        </div>
      </div>

      <div className="file-actions d-flex align-items-center margin-left-xs">
        {!fileHasMissingDetailsSize ? (
          <span className="margin-right-xs">{size}</span>
        ) : (
          <span className="margin-right-xs">{fileMissingDetailsSizeLabel}</span>
        )}
        <ButtonLink
          LinkComponent="a"
          className="btn btn-primary btn-sm"
          href={file.url}
          label={downloadLabel}
          hideLabelOnMobile={true}
          iconClassName="icon-arrow-right"
          iconPosition="after"
          target="_blank"
        />
      </div>
    </div>
  );
};

const LibraryFile_file = graphql__a9de7f3e4e3844c9b1e1;

export default LibraryFile;

const intlMessages = defineMessages({
  download: {
    id: "library.file.download",
    defaultMessage: "Télécharger"
  },
  fileMissingDetailsSizeLabel: {
    id: "library.file.fileMissingDetailsSizeLabel",
    defaultMessage: "Taille non disponible"
  },
  fileMissingDetailsExtensionLabel: {
    id: "library.file.fileMissingDetailsExtensionLabel",
    defaultMessage: "Extension non disponible"
  }
});
